export default __webpack_public_path__ + "static/media/ic-check-mark-correct.f4d88690.png";